import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const paidUploadLimit = getFeature('paid-upload-limit') || 107374182400; // 100 ГБ по дефолту
